(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amana-degraus"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.AmanaDegraus) return;

    function moeda(c, iso) {
      try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: iso || 'BRL' }); }
      catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    }

    /* Os textos usam [valor], [pct] e [atual]. O formato antigo da gaveta, com
       chaves duplas, ainda vale: a Shopify recusa chaves duplas em default de
       schema de seção usada em template JSON (lê como fonte dinâmica). */
    function marca(t) {
      return String(t || '').replace(/\{\{\s*(valor|pct|atual)\s*\}\}/g, '[$1]');
    }

    /* sub = subtotal dos itens antes do desconto de pedido; total = o que o
       frete enxerga (depois do desconto). Ambos em centavos. */
    function pinta(raiz, sub, total) {
      if (!raiz) return;
      sub = Number(sub) || 0;
      total = Number(total) || 0;
      var iso = raiz.getAttribute('data-am-dg-moeda') || 'BRL';
      var passos = Array.prototype.slice.call(raiz.querySelectorAll('[data-am-dg-passo]'));
      var n = passos.length;
      if (!n) return;

      var pctAtual = 0, prox = -1;
      passos.forEach(function (li, i) {
        var alvo = Number(li.getAttribute('data-alvo'));
        var base = li.getAttribute('data-base') === 't' ? total : sub;
        var ok = base >= alvo;
        var era = li.classList.contains('am-dg--ok');
        li.classList.toggle('am-dg--ok', ok);
        if (ok && !era) {
          /* a animação só roda uma vez por classe: tira, força o recálculo, põe */
          li.classList.remove('am-dg--novo');
          void li.offsetWidth;
          li.classList.add('am-dg--novo');
          setTimeout(function () { li.classList.remove('am-dg--novo'); }, 900);
        }
        if (ok) pctAtual = Math.max(pctAtual, Number(li.getAttribute('data-pct')) || 0);
        else if (prox === -1) prox = i;
      });

      /* posição da barra: centro da coluna de cada degrau, linear entre eles */
      var barra = 0, antAlvo = 0, antPos = 0;
      for (var i = 0; i < n; i++) {
        var alvo = Number(passos[i].getAttribute('data-alvo'));
        var pos = (i + 0.5) / n * 100;
        if (sub >= alvo) { barra = (i === n - 1) ? 100 : pos; antAlvo = alvo; antPos = pos; continue; }
        if (sub > antAlvo) barra = antPos + (pos - antPos) * (sub - antAlvo) / (alvo - antAlvo);
        break;
      }
      var i2 = raiz.querySelector('[data-am-dg-barra]');
      if (i2) {
        i2.style.setProperty('--am-p', barra.toFixed(1) + '%');
        var pb = i2.parentNode;
        if (pb) pb.setAttribute('aria-valuenow', Math.round(barra));
      }

      var msgEl = raiz.querySelector('[data-am-dg-msg]');
      if (!msgEl) return;
      var html, max = false;
      if (prox === -1) {
        html = marca(raiz.getAttribute('data-rot-max')).replace('[pct]', pctAtual);
        max = true;
      } else {
        var li = passos[prox];
        var alvoP = Number(li.getAttribute('data-alvo'));
        var frete = li.getAttribute('data-base') === 't';
        var falta = '<b>' + moeda(alvoP - (frete ? total : sub), iso) + '</b>';
        var molde = frete ? raiz.getAttribute('data-rot-frete-falta')
          : (pctAtual > 0 ? raiz.getAttribute('data-rot-mais') : raiz.getAttribute('data-rot-falta'));
        html = marca(molde).replace('[valor]', falta)
          .replace('[pct]', li.getAttribute('data-pct')).replace('[atual]', pctAtual);
      }
      if (msgEl.innerHTML !== html) {
        msgEl.innerHTML = html;
        msgEl.classList.remove('am-dg--troca');
        void msgEl.offsetWidth;
        msgEl.classList.add('am-dg--troca');
      }
      msgEl.classList.toggle('am-dg--max', max);
      raiz.setAttribute('data-am-dg-sub', sub);
      raiz.setAttribute('data-am-dg-total', total);
    }

    window.AmanaDegraus = { pinta: pinta };
  })();
  } catch(e) { console.error(e); }
})();

})();
